import React, { PropTypes, Component } from 'react';
import { Styles, List, ListItem, ListDivider, IconButton } from 'material-ui';
import * as Icons from 'components/Material/SvgIcons';
import update from 'react-addons-update';

const { Spacing } = Styles;

const styles = {
  root: {
    display: 'flex',
    borderWidth: 1
  },
  textAreaContainer: {
    flexGrow: 0
  },
  listContainer: {
    flexGrow: 1,
    minHeight: Spacing.desktopKeylineIncrement * 4,
    maxHeight: Spacing.desktopKeylineIncrement * 6,
    overflow: 'auto'
  },
  textarea: {
    height: 32 * 12,
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    outline: 'none',
    borderStyle: 'none solid none none',
    borderWidth: 1,
    lineHeight: 1.5,
    padding: Spacing.desktopGutterMini
  }
};

export default class InviteeAdder extends Component {
  static displayName = 'InviteeAdder';

  static propTypes = {
    initial: PropTypes.array,
    standAlone: PropTypes.bool
  };

  static contextTypes = {
    muiTheme: PropTypes.object,
    media: PropTypes.string,
    getIntlMessage: PropTypes.func
  };

  static defaultProps = {
    initial: [],
    standAlone: false
  };

  constructor() {
    super(...arguments);
    this.state = {
      invitees: this.props.initial,
      deleted: {}
    };
  }

  getInvitees() {
    return this.parseText();
  }

  getRootStyle() {
    let { media } = this.context;
    return Object.assign(styles.root, {
      flexDirection: this.context.media == 'phone' ? 'column' : 'row',
      borderColor: this.context.muiTheme.rawTheme.palette.borderColor,
      borderStyle: this.props.standAlone ? 'solid' : 'none solid solid solid'
    });
  }

  getContainerStyle() {
    return styles.listContainer;
  }

  getTextAreaStyle() {
    let { media } = this.context;
    return Object.assign(styles.textarea, {
      height:
        media === 'phone'
          ? Spacing.desktopKeylineIncrement * 2
          : Spacing.desktopKeylineIncrement * 6,
      borderColor: this.context.muiTheme.rawTheme.palette.borderColor
    });
  }

  getTextAreaContainerStyle() {
    let { media } = this.context;
    return Object.assign(styles.textAreaContainer, {
      width: media == 'phone' ? 'auto' : Spacing.desktopKeylineIncrement * 4,
      height:
        media === 'phone'
          ? Spacing.desktopKeylineIncrement * 2
          : Spacing.desktopKeylineIncrement * 6
    });
  }

  reset() {
    this.setState({
      invitees: [],
      deleted: {}
    });
  }

  isEmail(value) {
    var re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(value);
  }

  parseText(e = { keyCode: 13 }) {
    let value = (e && e.target && e.target.value) || this.refs.emails.value;
    let { keyCode } = e;
    const invitees = this.state.invitees.slice();
    let dirty = false;
    if (keyCode === 13) {
      let emails = value.split(/[\s,]+/);
      emails.forEach(email => {
        if (invitees.indexOf(email) < 0 && this.isEmail(email)) {
          invitees.push(email);
          dirty = true;
        }
      });

      if (e && e.target) {
        e.target.value = '';
      }
    }
    const filtered = invitees.filter(invitee => !this.state.deleted[invitee]);
    if (dirty) {
      this.setState({ invitees: filtered });
      if (this.props.onChange) {
        this.props.onChange(filtered);
      }
    }
    return filtered;
  }

  removeEmail(email) {
    const deleted = {
      ...this.state.deleted,
      [email]: true
    };
    const filtered = this.state.invitees.filter(invitee => !deleted[invitee]);
    const { onChange } = this.props;
    onChange && onChange(filtered);
    this.setState({ deleted });
  }

  render() {
    let items = [];
    items.push(<ListDivider key={'d'} />);
    this.state.invitees.forEach((email, index) => {
      if (!this.state.deleted[email]) {
        items.push(
          <ListItem
            key={'i-' + index}
            primaryText={email}
            rightIconButton={
              <IconButton onTouchTap={this.removeEmail.bind(this, email)}>
                <Icons.ContentClear />
              </IconButton>
            }
          />
        );
        items.push(<ListDivider key={'d-' + index} />);
      }
    });
    return (
      <div style={this.getRootStyle()}>
        <div style={this.getTextAreaContainerStyle()}>
          <textarea
            ref="emails"
            placeholder={this.context.getIntlMessage('invite.enterEmail')}
            onKeyUp={this.parseText.bind(this)}
            style={this.getTextAreaStyle()}
          />
        </div>
        <div style={this.getContainerStyle()}>
          <List subheader={this.context.getIntlMessage('invite.foundEmails')}>
            {items}
          </List>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/InviteeAdder.js